/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConnectedAccountPartial } from '../models/connected-account-partial';
import { ConnectedAccountResponseDto } from '../models/connected-account-response-dto';
import { DataSource } from '../models/data-source';
import { IngestMultipleDriveFilesRequestDto } from '../models/ingest-multiple-drive-files-request-dto';

@Injectable({
  providedIn: 'root',
})
export class DriveControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation driveControllerUpdateById
   */
  static readonly DriveControllerUpdateByIdPath = '/auth/drive/connected-account/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: ConnectedAccountPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: ConnectedAccountPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation driveControllerCallbackGoogle
   */
  static readonly DriveControllerCallbackGooglePath = '/auth/drive/google/callback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `callbackGoogle()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackGoogle$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerCallbackGooglePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `callbackGoogle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackGoogle(params?: {
  }): Observable<void> {

    return this.callbackGoogle$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation driveControllerCallbackMicrosoft
   */
  static readonly DriveControllerCallbackMicrosoftPath = '/auth/drive/microsoft/callback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `callbackMicrosoft()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackMicrosoft$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerCallbackMicrosoftPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `callbackMicrosoft$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  callbackMicrosoft(params?: {
  }): Observable<void> {

    return this.callbackMicrosoft$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation driveControllerConnect
   */
  static readonly DriveControllerConnectPath = '/auth/drive/{provider}/connect';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connect()` instead.
   *
   * This method doesn't expect any request body.
   */
  connect$Response(params: {
    provider: string;
    authorizationToken: string;
    accessKey?: string;
    secretAccessKey?: string;
    region?: string;
    bucketName?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerConnectPath, 'get');
    if (params) {
      rb.path('provider', params.provider, {});
      rb.query('authorizationToken', params.authorizationToken, {});
      rb.query('accessKey', params.accessKey, {});
      rb.query('secretAccessKey', params.secretAccessKey, {});
      rb.query('region', params.region, {});
      rb.query('bucketName', params.bucketName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `connect$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connect(params: {
    provider: string;
    authorizationToken: string;
    accessKey?: string;
    secretAccessKey?: string;
    region?: string;
    bucketName?: string;
  }): Observable<void> {

    return this.connect$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation driveControllerGetConnectedAccountByProvider
   */
  static readonly DriveControllerGetConnectedAccountByProviderPath = '/auth/drive/{provider}/connected-account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConnectedAccountByProvider()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConnectedAccountByProvider$Response(params: {
    provider: string;
  }): Observable<StrictHttpResponse<ConnectedAccountResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerGetConnectedAccountByProviderPath, 'get');
    if (params) {
      rb.path('provider', params.provider, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConnectedAccountResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getConnectedAccountByProvider$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConnectedAccountByProvider(params: {
    provider: string;
  }): Observable<ConnectedAccountResponseDto> {

    return this.getConnectedAccountByProvider$Response(params).pipe(
      map((r: StrictHttpResponse<ConnectedAccountResponseDto>) => r.body as ConnectedAccountResponseDto)
    );
  }

  /**
   * Path part for operation driveControllerDeleteConnectedAccountByProvider
   */
  static readonly DriveControllerDeleteConnectedAccountByProviderPath = '/auth/drive/{provider}/connected-account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteConnectedAccountByProvider()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConnectedAccountByProvider$Response(params: {
    provider: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerDeleteConnectedAccountByProviderPath, 'delete');
    if (params) {
      rb.path('provider', params.provider, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteConnectedAccountByProvider$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConnectedAccountByProvider(params: {
    provider: string;
  }): Observable<any> {

    return this.deleteConnectedAccountByProvider$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation driveControllerGetFileContent
   */
  static readonly DriveControllerGetFileContentPath = '/auth/drive/{provider}/file-content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFileContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileContent$Response(params: {
    provider: string;
    fileId: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerGetFileContentPath, 'get');
    if (params) {
      rb.path('provider', params.provider, {});
      rb.query('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFileContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileContent(params: {
    provider: string;
    fileId: string;
  }): Observable<Blob> {

    return this.getFileContent$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation driveControllerListFiles
   */
  static readonly DriveControllerListFilesPath = '/auth/drive/{provider}/file-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFiles$Response(params: {
    provider: string;
    fileName?: string;
    type?: string;
    parentId?: string;
    limit?: number;
    fileId?: string;
  }): Observable<StrictHttpResponse<Array<{ [key: string]: any }>>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerListFilesPath, 'get');
    if (params) {
      rb.path('provider', params.provider, {});
      rb.query('fileName', params.fileName, {});
      rb.query('type', params.type, {});
      rb.query('parentId', params.parentId, {});
      rb.query('limit', params.limit, {});
      rb.query('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{ [key: string]: any }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFiles(params: {
    provider: string;
    fileName?: string;
    type?: string;
    parentId?: string;
    limit?: number;
    fileId?: string;
  }): Observable<Array<{ [key: string]: any }>> {

    return this.listFiles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{ [key: string]: any }>>) => r.body as Array<{ [key: string]: any }>)
    );
  }

  /**
   * Path part for operation driveControllerUploadFile
   */
  static readonly DriveControllerUploadFilePath = '/auth/drive/{provider}/file-upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile$Response(params: {
    provider: string;
    fileKey: string;
    contentType?: string;

    /**
     * File upload
     */
    body: { 'file'?: Blob }
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerUploadFilePath, 'post');
    if (params) {
      rb.path('provider', params.provider, {});
      rb.query('fileKey', params.fileKey, {});
      rb.query('contentType', params.contentType, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile(params: {
    provider: string;
    fileKey: string;
    contentType?: string;

    /**
     * File upload
     */
    body: { 'file'?: Blob }
  }): Observable<void> {

    return this.uploadFile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation driveControllerIngestMultipleDriveFiles
   */
  static readonly DriveControllerIngestMultipleDriveFilesPath = '/auth/drive/{provider}/ingest-multiple-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ingestMultipleDriveFiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ingestMultipleDriveFiles$Response(params: {
    provider: string;
    body?: IngestMultipleDriveFilesRequestDto
  }): Observable<StrictHttpResponse<DataSource>> {

    const rb = new RequestBuilder(this.rootUrl, DriveControllerService.DriveControllerIngestMultipleDriveFilesPath, 'post');
    if (params) {
      rb.path('provider', params.provider, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSource>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ingestMultipleDriveFiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ingestMultipleDriveFiles(params: {
    provider: string;
    body?: IngestMultipleDriveFilesRequestDto
  }): Observable<DataSource> {

    return this.ingestMultipleDriveFiles$Response(params).pipe(
      map((r: StrictHttpResponse<DataSource>) => r.body as DataSource)
    );
  }

}
